import { z } from "zod"

// Definition of the TariffRateBand schema
export const tariffRateBandSchema = z.object({
  /** Unique Genability ID for each Band */
  tariffRateBandId: z.number().nullable().optional(),
  /** ID of the rate this band belongs to */
  tariffRateId: z.number().nullable(),
  /** Position of this band in the bands for its rate */
  rateSequenceNumber: z.number().nullable(),
  /** Indicates if this band has banded consumption */
  hasConsumptionLimit: z.boolean().nullable(),
  /** Upper consumption limit of this band (null means no upper limit) */
  consumptionUpperLimit: z.number().nullable().optional(),
  /** Indicates if this band has banded demand */
  hasDemandLimit: z.boolean().nullable().optional(),
  /** Upper demand limit of this band (null means no upper limit) */
  demandUpperLimit: z.number().nullable().optional(),
  /** Indicates if this band has a limit based on a property */
  hasPropertyLimit: z.boolean().nullable(),
  /** Upper limit of this band based on a property (null means no upper limit) */
  propertyUpperLimit: z.number().nullable().optional(),
  /** Upper limit of the previous rate band for this rate */
  prevUpperLimit: z.number().nullable().optional(),
  /** Value of the applicability property that
   * qualifies for this rate (nullable) */
  applicabilityValue: z.string().nullable().optional(),
  applicabilityFormula: z.string().nullable().optional(),
  /** Factor to be applied to the cost of the rate */
  calculationFactor: z.number().optional(),
  /** Charge amount for this band */
  rateAmount: z.number().nullable(),
  /** Unit of the rate (e.g. COST_PER_UNIT, PERCENTAGE) */
  rateUnit: z.enum([`COST_PER_UNIT`, `PERCENTAGE`]),
  /** Indicates if this band is a credit amount (reduces the bill) */
  isCredit: z.boolean(),
})

export type TariffRateBand = z.infer<typeof tariffRateBandSchema>
